export default {
  red: {
    header: {
      bg: '#D32F2F',
      text: '#fff'
    },
    launcher: {
      bg: '#D32F2F'
    },
    messageList: {
      bg: '#fff'
    },
    sentMessage: {
      bg: '#F44336',
      text: '#fff'
    },
    receivedMessage: {
      bg: '#eaeaea',
      text: '#222222'
    },
    userInput: {
      bg: '#fff',
      text: '#212121'
    },
    userList: {
      bg: '#fff',
      text: '#212121'
    },
    link: {
      text: '#4e8cff'
    }
  },
  green: {
    header: {
      bg: '#388E3C',
      text: '#fff'
    },
    launcher: {
      bg: '#388E3C'
    },
    messageList: {
      bg: '#fff'
    },
    sentMessage: {
      bg: '#4CAF50',
      text: '#fff'
    },
    receivedMessage: {
      bg: '#eaeaea',
      text: '#222222'
    },
    userInput: {
      bg: '#fff',
      text: '#212121'
    },
    userList: {
      bg: '#fff',
      text: '#212121'
    },
    link: {
      text: '#4e8cff'
    }
  },
  blue: {
    header: {
      bg: '#4e8cff',
      text: '#ffffff'
    },
    launcher: {
      bg: '#4e8cff'
    },
    messageList: {
      bg: '#ffffff'
    },
    sentMessage: {
      bg: '#4e8cff',
      text: '#ffffff'
    },
    receivedMessage: {
      bg: '#eaeaea',
      text: '#222222'
    },
    userInput: {
      bg: '#f4f7f9',
      text: '#565867'
    },
    userList: {
      bg: '#fff',
      text: '#212121'
    },
    link: {
      text: '#4e8cff'
    }
  },
  dark: {
    header: {
      bg: '#34495e',
      text: '#ecf0f1'
    },
    launcher: {
      bg: '#34495e'
    },
    messageList: {
      bg: '#2c3e50'
    },
    sentMessage: {
      bg: '#1d9bf0',
      text: '#ecf0f1'
    },
    receivedMessage: {
      bg: '#7f8c8d',
      text: '#ecf0f1'
    },
    userInput: {
      bg: '#34495e',
      text: '#ecf0f1'
    },
    userList: {
      bg: '#2c3e50',
      text: '#ecf0f1'
    },
    link: {
      text: '#fff'
    }
  }
}
